<template>
  <component :is="component" v-bind="$attrs" v-on="$listeners"></component>
</template>
<script>
import { skinList } from '@/config';
export default {
  data() {
    return {
      component: '',
    };
  },
  created() {
    const skin = this.$getStorage('skin') || '';
    if (!skin || !skinList.includes(skin)) {
      this.component = () => import(`./common.vue`);
    } else {
      this.component = () => import(`./${skin}.vue`);
    }
  },
  methods: {
  }
};
</script>
